<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useEntitiesStore } from '@/stores/useEntitiesStore'
import ExpendeduriaListComponent from '@/components/expendedurias/ExpendeduriaListComponent.vue'

const router = useRouter()
const store = useEntitiesStore()

// Control del modal de creación de Expendeduría
const showCreateModal = ref(false)

// Abrir el modal de creación
const handleOpenCreateModal = () => {
  showCreateModal.value = true
}

// Redirigir al detalle/máquinas cuando se selecciona un estanco de la lista
const handleSelectExpendeduria = (id: number) => {
  router.push({ name: 'expendeduria-detail', params: { id } })
}
</script>

<template>
  <div class="expendedurias-view py-3">
    <!-- CONTENIDO PRINCIPAL: LISTADO -->
    <ExpendeduriaListComponent 
      @create="handleOpenCreateModal"
      @select-expendeduria="handleSelectExpendeduria"
    />

    <!-- MODAL DE CREACIÓN (OPCIONAL/FUTURO) -->
    <!-- 
    <CreateExpendeduriaModal 
      v-if="showCreateModal" 
      @close="showCreateModal = false"
      @created="store.fetchExpendedurias()" 
    /> 
    -->
  </div>
</template>

<style scoped>
.expendedurias-view {
  min-height: 100vh;
  background-color: #f8f9fa;
}
</style>